export abstract class UserDao {
  abstract bootstrapCurrentUser(): Promise<number>
}
